var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstadisticas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.319824,
    y: 0.563477,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E0DFFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5199 10.9635C14.8834 10.9635 14.2729 11.2164 13.8228 11.6664C13.3727 12.1165 13.1199 12.727 13.1199 13.3635V27.7635C13.1199 28.4 13.3727 29.0105 13.8228 29.4606C14.2729 29.9106 14.8834 30.1635 15.5199 30.1635H25.1199C25.7564 30.1635 26.3668 29.9106 26.8169 29.4606C27.267 29.0105 27.5199 28.4 27.5199 27.7635V17.4603C27.5197 16.8238 27.2668 16.2135 26.8167 15.7635L22.7199 11.6667C22.2699 11.2166 21.6595 10.9636 21.0231 10.9635H15.5199ZM17.9199 22.9635C17.9199 22.6452 17.7934 22.34 17.5684 22.115C17.3434 21.8899 17.0381 21.7635 16.7199 21.7635C16.4016 21.7635 16.0964 21.8899 15.8713 22.115C15.6463 22.34 15.5199 22.6452 15.5199 22.9635V26.5635C15.5199 26.8818 15.6463 27.187 15.8713 27.412C16.0964 27.6371 16.4016 27.7635 16.7199 27.7635C17.0381 27.7635 17.3434 27.6371 17.5684 27.412C17.7934 27.187 17.9199 26.8818 17.9199 26.5635V22.9635ZM20.3199 19.3635C20.6381 19.3635 20.9434 19.4899 21.1684 19.715C21.3934 19.94 21.5199 20.2452 21.5199 20.5635V26.5635C21.5199 26.8818 21.3934 27.187 21.1684 27.412C20.9434 27.6371 20.6381 27.7635 20.3199 27.7635C20.0016 27.7635 19.6964 27.6371 19.4713 27.412C19.2463 27.187 19.1199 26.8818 19.1199 26.5635V20.5635C19.1199 20.2452 19.2463 19.94 19.4713 19.715C19.6964 19.4899 20.0016 19.3635 20.3199 19.3635ZM25.1199 18.1635C25.1199 17.8452 24.9934 17.54 24.7684 17.315C24.5434 17.0899 24.2381 16.9635 23.9199 16.9635C23.6016 16.9635 23.2964 17.0899 23.0713 17.315C22.8463 17.54 22.7199 17.8452 22.7199 18.1635V26.5635C22.7199 26.8818 22.8463 27.187 23.0713 27.412C23.2964 27.6371 23.6016 27.7635 23.9199 27.7635C24.2381 27.7635 24.5434 27.6371 24.7684 27.412C24.9934 27.187 25.1199 26.8818 25.1199 26.5635V18.1635Z",
    fill: "#6564DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstadisticas);
export default __webpack_public_path__ + "static/media/estadisticas.4c5b1fde7cbf05b0d70d32533ab4255a.svg";
export { ForwardRef as ReactComponent };